// extracted by mini-css-extract-plugin
export default {"custom__CheckBox":"MyCheckBox_custom__CheckBox__GMIcb"};